export default "__VITE_ASSET__BhuwpJfO__"